import Banner1 from "../../assets/img/Banner/banner1.png";
import Banner2 from "../../assets/img/Banner/banner2.png";
import Banner3 from "../../assets/img/Banner/banner3.png";
import Banner4 from "../../assets/img/Banner/banner4.png";

export const bannerImages = [
  {
    img: Banner1,
  },
  {
    img: Banner2,
  },
  {
    img: Banner3,
  },
  {
    img: Banner4,
  },
];
